function MonthPlugin() {
  return fp => ({
    onReady: () => {
      /* eslint no-param-reassign: ["error", { "props": false }] */
      fp.innerContainer.innerHTML = '';
    },
  });
}

export default MonthPlugin;



// WEBPACK FOOTER //
// ../widgets/day-overrides/month-plugin.js